import { useEffect, useRef } from 'react';

export const useEscapeKeyListener = (callback) => {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    const handleEscapeClick = (e) => {
        if (e.key === 'Escape') {
            callbackRef.current();
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleEscapeClick);

        return () => {
            window.removeEventListener('keydown', handleEscapeClick);
        };
    }, []);
};
